import React, { useCallback, useRef } from "react";
import { Button } from "@/components/ui/button";
import { ContentBlockList } from "@/modules/hub/features/ResourceManagement/components/ContentBlockList/ContentBlockList";
import { ContentBlockEditorProps } from "@/modules/hub/features/ResourceManagement/components/ContentBlockEditor/types";
import {
  BlockType,
  ContentBlockBase,
} from "@/modules/hub/features/ResourceManagement/components/SortableBlock/types";

export function ContentBlockEditor({
  blocks,
  onChange,
}: ContentBlockEditorProps) {
  const listContainerRef = useRef<HTMLDivElement>(null);

  const handleAddBlock = useCallback(
    (blockType: BlockType) => {
      const newBlock: ContentBlockBase = {
        id: crypto.randomUUID(),
        type: blockType,
        content: "",
        order_number: blocks.length,
      };

      const updated = [...blocks, newBlock];
      onChange(updated);

      setTimeout(() => {
        if (listContainerRef.current) {
          listContainerRef.current.scrollTo({
            top: listContainerRef.current.scrollHeight,
            behavior: "smooth",
          });
        }
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth",
        });
      }, 0);
    },
    [blocks, onChange],
  );

  const handleBlocksChange = useCallback(
    (updatedBlocks: ContentBlockBase[]) => {
      onChange(updatedBlocks);
    },
    [onChange],
  );

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-2">
        <Button
          onClick={() => handleAddBlock("text")}
          size="sm"
          type="button"
          variant="outline"
        >
          Add Text
        </Button>
        <Button
          onClick={() => handleAddBlock("image")}
          size="sm"
          type="button"
          variant="outline"
        >
          Add Image
        </Button>
        <Button
          onClick={() => handleAddBlock("file")}
          size="sm"
          type="button"
          variant="outline"
        >
          Add File
        </Button>
        <Button
          onClick={() => handleAddBlock("link")}
          size="sm"
          type="button"
          variant="outline"
        >
          Add Link
        </Button>
        <Button
          onClick={() => handleAddBlock("video")}
          size="sm"
          type="button"
          variant="outline"
        >
          Add Video
        </Button>
        <Button
          onClick={() => handleAddBlock("audio")}
          size="sm"
          type="button"
          variant="outline"
        >
          Add Audio
        </Button>
        <Button
          onClick={() => handleAddBlock("resource_reference")}
          size="sm"
          type="button"
          variant="outline"
        >
          Add Resource References
        </Button>
        <Button
          onClick={() => handleAddBlock("faq")}
          size="sm"
          type="button"
          variant="outline"
        >
          Add FAQ
        </Button>
        <Button
          onClick={() => handleAddBlock("columns")}
          size="sm"
          type="button"
          variant="outline"
        >
          Add Columns
        </Button>
        <Button
          onClick={() => handleAddBlock("quote")}
          size="sm"
          type="button"
          variant="outline"
        >
          Add Quote
        </Button>
        <Button
          onClick={() => handleAddBlock("heading")}
          size="sm"
          type="button"
          variant="outline"
        >
          Add Heading
        </Button>
      </div>

      <ContentBlockList
        blocks={blocks}
        onChange={handleBlocksChange}
        ref={listContainerRef}
      />
    </div>
  );
}
